module.exports = __webpack_public_path__ + "static/media/partitions_material_10y_n.066545c5.csv";